import moment from 'moment';

moment.locale('de');

export function minutesToTime(minutes: number): string {
    return moment().startOf('day').add(minutes, 'minutes').format('HH:mm');
}

export function timeToMinutes(time: string): number {
    return moment(time, 'HH:mm').diff(moment().startOf('day'), 'minutes');
}
